import {Basket, Product} from "./domain.ts";
import axios from "axios";
import {NewBasketPayload} from "../useBasket.tsx";
import {deleteBasketIDFromLS} from "./storage.ts";
import {getClientUID} from "../helpers.ts";

async function createBasketAPI(ownerID:string, salePoint: string, products: Product[]){
    const result = await axios.post(`/basket`, {
        ownerID:getClientUID(),
        sellingPoint: salePoint,
        shortUID:true,
        products: products,
    } as NewBasketPayload)
    return result.data as Basket
}

const loadBasketFromAPIByID = async (basketID:string, ownerID:string, salepointRef: string):Promise<Basket> =>  {
    try {
        const result = await axios.get(`/basket?ownerID=${ownerID}&basketID=${basketID}&shopID=${salepointRef}`)
        return result.data
    } catch (e) {
        if (e?.response?.data?.error == "basket not exists") {
            deleteBasketIDFromLS()
            return {products:[],id:""}
        }
    }
}
const loadBasketsList = async (ownerID:string, salepointRef:string): Promise<Array<Basket>> => {
    const baskets = await axios.get(`/basket/list?ownerID=${ownerID}&shopID=${salepointRef}`)
    return baskets.data
}
export {createBasketAPI, loadBasketFromAPIByID, loadBasketsList}